import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

function Topmenuleft() {
  return (
    <nav class="navbar navbar-expand-lg">

    

        <button data-mdb-button-init class="navbar-toggler px-0" type="button" data-mdb-collapse-init
          data-mdb-target="#navbarExampleOnHover" aria-controls="navbarExampleOnHover" aria-expanded="false"
          aria-label="Toggle navigation">
        </button>

        <div class="collapse navbar-collapse" id="navbarExampleOnHover">

          <ul class="navbar-nav">
            <li class="nav-item first">
               <Link className='nav-link' to='/home'>Home</Link>
            </li>

            <li class="nav-item">
               <Link className='nav-link' to='/about'>About</Link>
            </li>

            {/* <li class="nav-item dropdown dropdown-hover ">
              <a data-mdb-dropdown-init class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-mdb-toggle="dropdown" aria-expanded="false">
                About 
              </a>
              <div class="dropdown-menu mt-0" aria-labelledby="navbarDropdown" >
                <ul>
                  <li><Link className='order-history-link' to='/about'>About Aadikaash</Link></li>
                  <li><Link className='order-history-link' to='/about-isjs'>About ISJS</Link></li>
                  <li><Link className='order-history-link' to='/about-asjs'>About ASJS</Link></li>
                </ul>
              </div>
            </li> */}

            <li class="nav-item dropdown dropdown-hover">
              <a data-mdb-dropdown-init class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-mdb-toggle="dropdown" aria-expanded="false">
              Exhibitor
              </a>

              <div class="dropdown-menu mt-0" aria-labelledby="navbarDropdown" >
                <ul>
                {/* <li> <Link to='https://crm.aadikaash.com/exhibitor/login' className='order-history-link'>Exhibitor Login</Link></li> */}

                <li> <Link to='/dashboard' className='order-history-link'>Exhibitor Login</Link></li> 
                {/* <li> <Link to='/' className='order-history-link'>ISJS 2025 Application</Link></li> */}
                {/* <li> <Link to='#' className='order-history-link'>AIJE 2026 Application</Link></li> */}
                <li> <Link to='/'>Floor Plan Download</Link></li>
                </ul>
              </div>
            </li>

              <li class="nav-item">
               <Link className='nav-link' to='https://crm.aadikaash.com/visitor'>Visitor</Link>
            </li>

            {/* <li class="nav-item dropdown dropdown-hover ">
              <a data-mdb-dropdown-init class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-mdb-toggle="dropdown" aria-expanded="false">
              <span class="blink-live upcoming">upcoming</span>Visitor
              </a>

              <div class="dropdown-menu mt-0" aria-labelledby="navbarDropdown" >
                <ul>
                <li><a href="https://perfectdatas.in/aije/visitor" target='_blank'>ISJS 2025 Registration</a></li>
                <li><a href="https://perfectdatas.in/aije/visitor" target='_blank'>ASJS 2025 Registration</a></li>
                </ul>
              </div>
            </li> */}

          </ul>

        </div>

     

    </nav>
  )

}

export default Topmenuleft;
